/** Pestañas del diálogo Editar cliente accesibles vía query ?tab= */
export const CLIENTES_EDIT_TAB_VALUES = Object.freeze([
  "credenciales",
  "constancia",
  "obligaciones",
]);

const EDIT_TAB_SET = new Set(CLIENTES_EDIT_TAB_VALUES);

/**
 * @param {string | null | undefined} tab
 * @returns {"credenciales"|"constancia"|"obligaciones"|null}
 */
export function parseClientesEditTab(tab) {
  const raw = String(tab || "").trim().toLowerCase();
  return EDIT_TAB_SET.has(raw) ? raw : null;
}

/**
 * @param {{ clientId?: string, tab?: string, extra?: Record<string, string> }} opts
 */
export function buildClientesDeepLink({ clientId, tab, extra } = {}) {
  const params = new URLSearchParams();
  if (clientId) params.set("client", String(clientId));
  const parsedTab = parseClientesEditTab(tab);
  if (parsedTab) params.set("tab", parsedTab);
  if (extra && typeof extra === "object") {
    for (const [key, value] of Object.entries(extra)) {
      if (value != null && String(value).trim()) params.set(key, String(value));
    }
  }
  const qs = params.toString();
  return qs ? `/clientes?${qs}` : "/clientes";
}
